import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '热血战斗', href: '/category/action' },
  { label: '奇幻冒险', href: '/category/fantasy' },
  { label: '恋爱日常', href: '/category/romance' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 group cursor-pointer whitespace-nowrap"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-flower-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-heading font-semibold text-foreground-950">
                樱花动漫
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => {
                const isActive = location.pathname === link.href;
                return (
                  <Link
                    key={link.href}
                    to={link.href}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                    }`}
                  >
                    {link.label}
                  </Link>
                );
              })}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <button
                type="button"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-foreground-700"></i>
              </button>
            </div>

            <button
              type="button"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-lg text-foreground-700 ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        <div
          className={`md:hidden transition-all duration-300 overflow-hidden ${
            isMobileOpen ? 'max-h-80' : 'max-h-0'
          }`}
        >
          <div className="px-4 pb-4 pt-2 bg-background-50 border-t border-background-200/70 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      </nav>
      <div className="h-16"></div>
    </>
  );
}